import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { api, eur } from "@/lib/api";

const untilMidnight = () => {
  const now = new Date();
  const end = new Date(now);
  end.setHours(24, 0, 0, 0);
  return Math.max(0, end - now);
};

const Countdown = () => {
  const [ms, setMs] = useState(untilMidnight());
  useEffect(() => {
    const t = setInterval(() => setMs(untilMidnight()), 1000);
    return () => clearInterval(t);
  }, []);
  const parts = [ms / 3.6e6, (ms / 6e4) % 60, (ms / 1e3) % 60].map((v) => String(Math.floor(v)).padStart(2, "0"));
  return (
    <div className="flex items-center gap-1" data-testid="flash-countdown">
      {parts.map((p, i) => (
        <span key={i} className="flex items-center gap-1">
          <span className="font-mono text-2xl md:text-3xl bg-white text-[#0F0F0F] px-2 py-1 tabular-nums">{p}</span>
          {i < 2 && <span className="font-mono text-2xl">:</span>}
        </span>
      ))}
    </div>
  );
};

export const FlashDeals = () => {
  const [deals, setDeals] = useState([]);
  useEffect(() => { api.get("/deals/flash").then((r) => setDeals(r.data)); }, []);
  if (!deals.length) return null;

  return (
    <section className="bg-[#FF3333] text-white border-b border-[#0F0F0F]" data-testid="flash-deals">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-8 grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
        <div className="lg:col-span-4 space-y-3">
          <span className="tag flex items-center gap-2"><Zap size={14} fill="white" /> Offerte lampo</span>
          <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight leading-none">Solo fino a mezzanotte</h2>
          <Countdown />
        </div>
        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
          {deals.map((p) => (
            <Link key={p.id} to={`/prodotto/${p.id}`} data-testid={`flash-deal-${p.id}`}
              className="bg-white text-[#0F0F0F] border border-[#0F0F0F] flex gap-3 p-3 brut-hover">
              <img src={p.image} alt={p.title} className="w-20 h-20 object-cover border border-[#0F0F0F] shrink-0" />
              <div className="min-w-0 flex flex-col">
                <span className="tag text-[#FF3333]">-{p.discount}%</span>
                <p className="text-sm font-medium line-clamp-2 leading-snug">{p.title}</p>
                <p className="mt-auto font-display font-black text-xl">{eur(p.price)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
